import defaultAttributes from '../defaultAttributes';

const Undo = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M3 7v6h6' }],
    ['path', { d: 'M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13' }],
  ],
];

export default Undo;
